import { render, staticRenderFns } from "./WallTextBlock.vue?vue&type=template&id=6d69c642"
import script from "./WallTextBlock.vue?vue&type=script&lang=js"
export * from "./WallTextBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports